import { render, staticRenderFns } from "./BAutocomplete.vue?vue&type=template&id=1571a304&scoped=true"
import script from "./BAutocomplete.vue?vue&type=script&lang=js"
export * from "./BAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1571a304",
  null
  
)

export default component.exports